import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// GUARDS & RESOLVERS
import { AuthGuard } from './global/auth.guard';

// 404
import { UnknownRouteComponent } from './view-routes/unknown-route/unknown-route.component';

// ROUTES
const routes: Routes = [
	// OUTSIDE - NOT LOGGED IN
	{
		path: 'outside',
		pathMatch: 'prefix',
		data: { state: 'outside' },
		loadChildren: () =>
			import('./view-routes/outside/outside.module').then(m => m.OutsideModule)
	},

	// SSO CALLBACK - shared landing path for the backend SSO redirect (reads token from URL fragment)
	{
		path: 'sso-auth',
		loadComponent: () =>
			import('./view-routes/sso-auth/sso-auth.component').then(m => m.SsoAuthComponent),
		data: { state: 'SSO' }
	},

	// INSIDE - AUTHENTICATED
	{
		path: '',
		pathMatch: 'full',
		redirectTo: 'inside'
	},
	{
		path: 'inside',
		canLoad: [AuthGuard],
		data: { state: 'inside' },
		loadChildren: () =>
			import('./view-routes/inside/inside.module').then(m => m.InsideModule)
	},
	{
		path: 'public',
		canLoad: [AuthGuard],
		data: { state: 'inside' },
		loadChildren: () =>
			import('./view-routes/inside/inside.module').then(m => m.InsideModule)
	},

	// 404
	{
		path: '**',
		pathMatch: 'full',
		component: UnknownRouteComponent,
		data: { state: 'unknown' }
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
	exports: [RouterModule]
})
export class AppRoutingModule {}
